import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { HexColor } from '../ColorPickerPopover/ColorPickerPopover';
import { ColorPickerPopover } from '../index';

interface ControlledColorPickerPopoverProps {
  name: string;
  label: string;
}

export const ControlledColorPickerPopover: React.FC<
  ControlledColorPickerPopoverProps
> = ({ label, name }) => {
  const { control, setValue } = useFormContext();

  function onColorSelect(color: HexColor) {
    setValue(name, color);
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <ColorPickerPopover
            color={field.value}
            onColorSelected={onColorSelect}
            hasEditFeature={true}
            label={label}
          />
        </div>
      )}
    />
  );
};
